<template>
  <div class="agreement" :class="{ wide: isWideScreen }">
    <div class="ag-header">
      <div class="brand">元收纳</div>
      <h1 class="ag-title">会员服务协议</h1>
      <div class="ag-meta">
        <span>生效日期：2026年8月1日</span>
      </div>
    </div>

    <div class="ag-body">
      <section class="sec">
        <h2>一、总则</h2>
        <p>欢迎使用"元收纳"（以下简称"本应用"）会员服务。请您在购买会员前仔细阅读本协议。购买会员即表示您充分理解并同意接受本协议的全部内容。</p>
        <p>本协议是您与本应用开发方之间关于会员服务所订立的协议。如果您不同意本协议的任何内容，请勿购买或使用会员服务。</p>
      </section>

      <section class="sec">
        <h2>二、会员类型与权益</h2>
        <p>本应用提供以下会员类型：</p>
        <ol class="num">
          <li>月度会员：自购买之日起有效期1个月内，享受会员全部权益；</li>
          <li>年度会员：自购买之日起有效期365天，享受会员全部权益；</li>
        </ol>
        <p>会员权益包括但不限于：</p>
        <ol class="circle">
          <li>无限收纳空间数量；</li>
          <li>添加物品数量不限；</li>
          <li>热区与链接数量无限；</li>
          <li>备份与恢复功能。</li>
        </ol>
        <p>具体权益内容以购买时页面展示为准，本应用有权根据业务发展调整会员权益，调整后将通过应用内通知或其他合理方式告知您。</p>
      </section>

      <section class="sec">
        <h2>三、购买与支付</h2>
        <ol class="num">
          <li>您通过{{ brand }}应用内支付（IAP）购买会员服务，支付成功后会员权益即时生效。</li>
          <li>会员价格以购买页面显示为准。</li>
          <li>自动续期订阅会员将在当前周期到期前24小时内自动扣费续订，扣费金额以当前订阅价格为准。您可以在{{ brand }}账号订阅管理中随时关闭自动续订。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>四、自动续订说明</h2>
        <ol class="num">
          <li>月度会员和年度会员为自动续期订阅商品，购买后默认开启自动续订。</li>
          <li>自动续订扣费时间为当前会员周期到期前24小时内。</li>
          <li>如需取消自动续订，请您在到期前至少24小时通过{{ brand }}账号设置 &gt; 订阅管理中手动关闭，关闭后当前会员周期内仍可享受会员权益。</li>
          <li>取消自动续订后，如需再次享受会员权益，需重新购买会员。</li>
          <li>如因{{ brand }}账户余额不足或其他原因导致自动续订扣款失败，会员权益将在当前周期到期后停止。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>五、恢复购买</h2>
        <ol class="num">
          <li>若您更换设备或卸载重装本应用，可通过"恢复购买"功能恢复已购买的会员权益。</li>
          <li>恢复购买需使用购买时同一{{ brand }}账号登录。</li>
          <li>当前有效的订阅均可通过恢复购买找回。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>六、退款政策</h2>
        <ol class="num">
          <li>会员服务属于虚拟商品，购买成功后原则上不予退款。</li>
          <li>如因系统故障导致重复扣费或权益未生效，请通过{{ brand }}应用市场申请退款或联系客服处理。</li>
          <li>退款成功后，会员权益将同步到期后取消。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>七、会员账号与使用</h2>
        <ol class="num">
          <li>会员权益与购买时使用的{{ brand }}账号绑定，不可转让、出借或出售给他人。</li>
          <li>您应妥善保管{{ brand }}账号信息，因账号泄露导致的权益损失由您自行承担。</li>
          <li>如发现违规使用会员权益（包括但不限于账号共享、权益倒卖等），本应用有权终止您的会员资格且不予退款。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>八、免责声明</h2>
        <ol class="num">
          <li>本应用将尽最大努力保障会员服务的稳定运行，但不保证服务完全不间断、无错误。</li>
          <li>因不可抗力（包括但不限于自然灾害、政策变化、网络攻击等）导致服务中断或权益受影响，本应用不承担责任。</li>
          <li>本应用有权因系统维护、升级等原因暂停服务，将提前在应用内公告。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>九、协议变更</h2>
        <ol class="num">
          <li>本应用有权根据法律法规变化或业务需要修改本协议内容。</li>
          <li>修改后的协议将在应用内公示，若您在协议修改后继续使用会员服务，视为同意修改后的协议。</li>
          <li>如您不同意修改后的协议，可取消订阅并停止使用会员服务。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>十、其他</h2>
        <ol class="num">
          <li>本协议的订立、执行和解释均适用中华人民共和国法律。</li>
          <li>本协议未尽事宜，按照相关法律法规执行。</li>
          <li>如您对本协议有任何疑问，请通过电子邮件 <a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a> 与我们联系。</li>
        </ol>
      </section>

      <div class="ag-contact">联系我们：<a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "memberAgreement",
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    isIOS() {
      const q = (this.$route && this.$route.query) || {};
      const v = (q.os || q.platform || "").toString().toLowerCase();
      return v === "ios";
    },
    brand() {
      return this.isIOS ? "苹果" : "华为";
    },
  },
};
</script>

<style scoped>
.agreement {
  background: #fff;
  text-align: left;
  color: #1f2933;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.85;
  font-size: 16px;
  margin: 0 auto;
  max-width: 860px;
  padding: 24px 16px 48px;
}
.agreement.wide {
  padding: 36px 28px 56px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.ag-header {
  background: linear-gradient(135deg, #fdba74, #fb923c);
  color: #fff;
  text-align: center;
  padding: 32px 16px 26px;
  border-radius: 10px 10px 0 0;
  margin: -24px -16px 0;
}
.agreement.wide .ag-header {
  margin: -36px -28px 0;
}
.ag-header .brand {
  font-size: 0.95rem;
  letter-spacing: 0.18em;
  opacity: 0.92;
  margin-bottom: 8px;
}
.ag-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.04em;
}
.ag-meta {
  margin-top: 12px;
  font-size: 0.9rem;
  opacity: 0.9;
}
.ag-meta .dot {
  margin: 0 10px;
  opacity: 0.6;
}
.sec {
  margin-top: 28px;
}
.sec h2 {
  font-size: 1.12rem;
  color: #fb923c;
  margin: 0 0 12px;
  padding-left: 0.6em;
  border-left: 4px solid #fb923c;
  line-height: 1.5;
}
.sec p {
  margin: 0.6em 0;
}
ol.num {
  list-style: decimal;
  padding-left: 1.6em;
  margin: 0.6em 0;
}
ol.num > li {
  margin: 0.45em 0;
  padding-left: 0.2em;
}
ol.circle {
  list-style: none;
  counter-reset: c;
  padding-left: 1.7em;
  margin: 0.6em 0;
}
ol.circle > li {
  counter-increment: c;
  position: relative;
  margin: 0.45em 0;
}
ol.circle > li::before {
  content: "（" counter(c) "）";
  position: absolute;
  left: -1.7em;
  color: #fb923c;
  font-weight: 600;
}
.ag-note {
  margin-top: 26px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.88rem;
}
.ag-contact {
  margin-top: 18px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #7c3a0e;
  font-size: 0.95rem;
  text-align: center;
}
.ag-mail {
  color: #ea580c;
  text-decoration: none;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/agreements/yuanshou-na/member-service.vue